import {
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { FunctionComponent } from "react";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import {
  formatDate,
  getProductRedirectUrl,
  getProductTypeChip,
} from "../../../services/utilities/utility";
import { SetupType } from "../../../models/features/Integration/DmsSetup";
interface QuotationDetailDialogProps {
  isOpen: boolean;
  onClose: any;
  quotation: any;
}

const QuotationDetailDialog: FunctionComponent<QuotationDetailDialogProps> = ({
  quotation,
  isOpen,
  onClose,
}) => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  return (
    <>
      {!quotation !== undefined && (
        <Dialog
          open={isOpen}
          onClose={() => {
            onClose();
          }}
          maxWidth={"lg"}
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 0,
              paddingLeft: "39px",
              paddingRight: "39px",
            }}
          >
            <h4>Leads</h4>
            <IconButton
              onClick={() => {
                onClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: 0 }}>
            <Container maxWidth="xl">
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Customer Name</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {quotation?.firstName + " " + quotation?.lastName}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Email</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {quotation?.email}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Phone</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {quotation?.phone}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Title</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {quotation?.productTitle}
                  <IconButton
                    aria-label="viewOrder"
                    disabled={quotation?.productAggregate ? false : true}
                    size="small"
                    onClick={() => {
                      window.open(
                        getProductRedirectUrl(
                          dmsSetup?.siteDomain ?? "",
                          quotation?.productAggregate?.externalProductLink ??
                            "",
                          dmsSetup?.setupType ?? SetupType.Shopify,
                        ),
                        "_blank",
                      );
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Product Type</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {getProductTypeChip(quotation?.productAggregate?.type) ??
                    "N/A"}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Vendor</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {quotation?.productAggregate?.mfrName ?? "N/A"}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Date</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {formatDate(quotation?.createdAt)}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item sm={12}>
                  <Typography className="bold">Message</Typography>
                  <TextareaAutosize
                    aria-label="empty textarea"
                    placeholder="Message"
                    id={"description"}
                    name={"description"}
                    minRows={5}
                    style={{ width: "100%" }}
                    disabled
                    value={quotation?.message}
                  />
                </Grid>
              </Grid>
            </Container>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default QuotationDetailDialog;
